import Page from "layouts/Page";
import { Box, Divider, Heading } from "@chakra-ui/react";

export default function () {
  return (
    <Page>
      <Box bg="white" p={6} my={6} borderRadius="xl" boxShadow={"xl"}>
        <article>
          <Heading>Politique d'utilisation des données</Heading>
          <Divider />
          <p>En vigueur au 01/04/2022</p>
          <section>
            <p>
              La présente politique, la{" "}
              <strong>“Politique en matière de cookies”</strong>, a pour objet
              d’informer de manière claire, simple et complète les utilisateurs
              du présent site, l’<strong>”Utilisateur”</strong> ou{" "}
              <strong>“vous/votre/vos”</strong>, sur la manière dont Tête en
              l’Air, <strong>“TeteEnLair”</strong> ou
              <strong>“nous”</strong>, utilise les cookies sur son site, le
              <strong>“Site”</strong>.
            </p>
            <p>
              Un cookie est un ensemble d’informations déposées dans le terminal
              de l’Utilisateur lorsque celui-ci navigue sur le Site.
            </p>
            <p>
              Le dépôt de cookies publicitaires et/ou de mesure d’audience est
              soumis à votre consentement, c’est pour cela que vous trouverez en
              bas de notre site un bandeau cookies qui vous permet à tout moment
              d’accepter, paramétrer et/ou de refuser le dépôt de ces derniers.
              Vous avez également la possibilité de changer d’avis à tout moment
              via le gestionnaire mis à votre disposition ou via votre
              navigateur.
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>
              Quel type de cookies utilisons-nous ? Pour quelles finalités ?
            </Heading>
          </section>
          <section>
            <Heading fontSize={"lg"}>
              Des cookies strictement nécessaires
            </Heading>
            <p>
              Ces cookies sont nécessaires pour les opérations propres aux
              services et aux produits qui sont fournis sur le Site. Ils sont
              utilisés pour fournir les fonctionnalités basiques du Site, telles
              que se souvenir des informations qui ont été insérées dans un
              formulaire. Si vous empêchez l’installation de ces cookies, vous
              ne pourrez plus utiliser ces fonctionnalités et le Site pourrait
              ne pas fonctionner de façon efficace.
            </p>
          </section>
          <section>
            <Heading fontSize="lg">Des cookies de performance</Heading>
            <p>
              Ces cookies sont utilisés pour collecter des données anonymes à
              des fins statistiques. Ils nous permettent de mesurer l’audience
              du Site et d’analyser la façon dont les visiteurs surfent sur le
              Site (nombre de visiteurs sur le Site, nombre de visites par page,
              temps passé sur chaque page, localisation des clics…). Ils sont
              également utilisés pour détecter des problèmes de navigation et
              toute autre difficulté. Ces cookies nous aident à améliorer notre
              Site et votre navigation.
            </p>
          </section>
          <section>
            <Heading fontSize="lg">
              Des cookies de personnalisation ou de fonctionnalité
            </Heading>
            <p>
              Ces cookies sont utilisés pour se souvenir de vos choix, de vos
              réglages et de vos préférences de contenu sur le Site (comme votre
              langue, vos choix de personnalisation…) et vous offrir ainsi une
              expérience de navigation personnalisée en adaptant les contenus du
              Site pour vous. Si vous refusez ces cookies, nous ne pourrons plus
              vous offrir certaines fonctionnalités et certaines pages du Site
              pourraient ne pas fonctionner correctement.
            </p>
          </section>
          <section>
            <Heading fontSize="lg">Spécificité des cookies de partage</Heading>
            <p>
              Ces cookies sont spécifiquement liés à l’utilisation des boutons
              de partage d’une page du Site sur les réseaux sociaux (Instagram,
              Twitter). Les boutons de partage vous permettent de directement
              partager sur le réseau social concerné une page du Site. En
              cliquant sur le bouton de partage sur le réseau social concerné,
              un ou plusieurs cookies sont alors déposés sur votre terminal
              (ordinateur, smartphone, tablette) par le réseau social. Nous
              n’avons ni accès ni contrôle sur ces cookies de tiers, qui peuvent
              être des cookies analytiques, de performance ou de ciblage. Nous
              vous suggérons de consulter les sites internet de ces tiers pour
              plus d’informations au sujet de leurs cookies et pour savoir
              comment les gérer.
            </p>
          </section>
          <section>
            <Heading fontSize="lg">
              Réglage et blocage des cookies via notre gestionnaire de cookies
            </Heading>
            <p>
              La liste des cookies que nous utilisons est consultable via
              l’outil de gestion que nous avons mis en place. Vous avez la
              possibilité de les désactiver à tout moment. Néanmoins, nous
              attirons votre attention sur le fait que certains cookies sont
              indispensables au bon fonctionnement du Site et qu’il est donc
              déconseillé de les désactiver.
            </p>
          </section>
          <section>
            <Heading fontSize="lg">
              Réglage et blocage des cookies via vos paramètres de navigation
            </Heading>
            <p>
              Vous pouvez également contrôler les cookies grâce aux paramètres
              de votre navigateur. Si la plupart des navigateurs sont paramétrés
              par défaut et acceptent l’installation de cookies, vous avez la
              possibilité, si vous le souhaitez, de choisir d’accepter tous les
              cookies, ou de les rejeter systématiquement ou encore de choisir
              ceux que vous acceptez selon l’émetteur. Vous pouvez également
              paramétrer votre navigateur pour accepter ou refuser, au cas par
              cas, les cookies préalablement à leur installation. Vous pouvez
              également régulièrement supprimer les cookies de votre terminal
              via votre navigateur. <br />
              <br />
              L’utilisation de cookies ou de technologies similaires par tout
              site Internet tiers, fournisseur de contenu publicitaire est
              soumise à leur propre politique de confidentialité en matière de
              cookies.
              <br />
              <br /> La CNIL (Commission Nationale Informatique et Liberté)
              propose en téléchargement gratuit, un logiciel de gestion des
              cookies sur son site Internet : rendez-vous à l’adresse{" "}
              <a
                href="https://www.cnil.fr/vos-droits/vos-traces/les-cookies/"
                target="_blank"
              >
                https://www.cnil.fr/vos-droits/vos-traces/les-cookies/
              </a>{" "}
              pour en savoir plus.
            </p>
            <p>
              Pour la gestion des cookies et de vos choix, la configuration de
              chaque navigateur est différente. Elle est décrite dans le menu
              d’aide de votre navigateur, qui vous permettra de savoir de quelle
              manière modifier vos souhaits en matière de cookies.
            </p>
          </section>
          <section>
            <Heading fontSize="lg">A titre d’exemple :</Heading>
            <ul>
              <li>
                Pour Internet Explorer™ : 
                <a
                  href="https://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies"
                  target="_blank"
                >
                  https://windows.microsoft.com/fr-FR/windows-vista/Block-or-allow-cookies
                </a>
              </li>
              <li>
                Pour Safari™ : 
                <a
                  href="https://support.apple.com/fr-fr/guide/safari/sfri11471/mac"
                  target="_blank"
                >
                  https://support.apple.com/fr-fr/guide/safari/sfri11471/mac
                </a>
              </li>
              <li>
                Pour Chrome™ : 
                <a
                  href="https://support.google.com/chrome/bin/answer.py?hl=fr&hlrm=en&answer=95647"
                  target="_blank"
                >
                  https://support.google.com/chrome/bin/answer.py?hl=fr&hlrm=en&answer=95647
                </a>
              </li>
              <li>
                Pour Firefox™ : 
                <a
                  href="https://support.mozilla.org/fr/kb/Activer%20et%20d%C3%A9sactiver%20les%20cookies
                "
                  target="_blank"
                >
                  https://support.mozilla.org/fr/kb/Activer%20et%20d%C3%A9sactiver%20les%20cookies
                </a>
              </li>
            </ul>
          </section>
          <section>
            <Heading fontSize="lg">
              Paramétrage du système d’exploitation de votre smartphone
            </Heading>
            <p>
              Vous avez la possibilité de contrôler le dépôt des cookies sur
              votre smartphone dans les règles du système d’exploitation.
            </p>
            <ul>
              <li>
                Sur iOS : 
                <a
                  href="https://support.apple.com/fr-fr/HT201265"
                  target="_blank"
                >
                  https://support.apple.com/fr-fr/HT201265
                </a>
              </li>
              <li>
                Sur Android : 
                <a
                  href="https://support.google.com/chrome/topic/3434352"
                  target="_blank"
                >
                  https://support.google.com/chrome/topic/3434352
                </a>
              </li>
            </ul>
          </section>
          <section>
            <Heading fontSize="lg">
              Gérez vous-même vos préférences cookies sur le Site
            </Heading>
            <p>
              Lors de votre connexion au Site, vous aurez la possibilité
              d’effectuer un choix libre et éclairé en matière de dépôt de
              cookies. Vous pouvez à tout moment changer d’avis en cliquant sur
              le lien suivant :
            </p>
          </section>
        </article>
      </Box>
    </Page>
  );
}
